import { ref } from "vue"

/**
 * The user's personal currency preference (ISO code), mirrored from the
 * preferences singleton by firestoreStore when it loads/updates. Lives in its
 * own tiny module so useCurrency can read it without importing the (heavy,
 * circular-prone) firestoreStore.
 */
export const personalCurrency = ref<string | null>(null)
